import { App } from './app.class';
import { Fetch } from '../fetch.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';

export class Mailaddresses {

    // Initialisieren
    constructor(selector, storing=null, form_code='') {

        // Hauptelement
        this.$ele = document.querySelector(selector);

        // direkte Speicherung
        this.storing = storing;
        this.form_code = form_code;

        // Vars
        this.id = this.$ele.getAttribute('id');
        this.modalAddSelector = '#'+this.id+' .modal';
        this.maxCount = parseInt( this.$ele.getAttribute('data-maxcount') );
        this.addressesNotReleased = [];

        // Elemente
        this.$list = this.$ele.querySelector('ul.list');
        this.$listLiEmpty = this.$list.querySelector('li.empty');
        this.$value = this.$ele.querySelector('input[type=hidden]');
        this.$btnAdd = this.$ele.querySelector('.cont button');
        this.$modalInputSelect = this.$ele.querySelector(this.modalAddSelector+' .input-text-select');
        this.$modalBtnApply = this.$ele.querySelector(this.modalAddSelector+' button.apply');
        this.$modalError = this.$ele.querySelector(this.modalAddSelector+' .error');
        this.modal = new Modal(this.modalAddSelector);

        // Nachricht für nicht freigeschaltene Adressen
        this.msgNotReleased = this.$ele.getAttribute('data-msg-notreleased');

        // Öffnen des Modal
        this.$btnAdd.addEventListener('click', event => {

            // Fehler ausblenden
            this.$modalError.classList.add('hidden');

            // Modal anzeigen
            this.modal.show();
        });

        // Auswahl einer vorhandenen Adresse
        const $select = this.$modalInputSelect.querySelector('select');
        if($select) {
            $select.addEventListener('change', event => {
                const value = $select.value;
                const $input = $select.parentNode.querySelector('input');
                if($input) {
                    $input.value = value;
                }
            });
        }

        // Neue Adresse übernehmen
        this.$modalBtnApply.addEventListener('click', event => {
            const $input = this.$modalInputSelect.querySelector('input');
            if($input) {
                this.addAddress( $input.value );
            }
        });

        // Nicht bestätigte Adressen laden
        this.addressesNotReleased = [];
        const strNotreleased = this.$ele.getAttribute('data-addresses-notreleased');
        if(strNotreleased) {
            this.addressesNotReleased = strNotreleased.split(",");
        }

        // Liste anzeigen
        this.updateList();
    }

    // Anzeige der Liste aktualisieren
    updateList() {

        // Liste der Adressen
        const addresses = this.getAddresses();

        // vorhandene Einträge entfernen
        const entries = this.$list.querySelectorAll('li.entry');
        entries.forEach(el => {
            el.parentNode.removeChild(el);
        });

        // keine Adressen gewählt
        if(addresses.length === 0) {
            this.$listLiEmpty.style.display = 'flex';
        }

        // Adressen vorhanden
        else {
            this.$listLiEmpty.style.display = 'none';
            addresses.forEach(address => {
                const element = document.createElement('li');
                element.classList.add('entry');

                const html = `
<div>
    <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
    <span>`+address+`</span>
</div>
<div>
    <button type="button" class="info hint--top-left" aria-label="`+this.msgNotReleased+`" tabindex="-1">
        <svg class="text-yellow-400" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" fill-rule="evenodd"></path></svg>
    </button>
    <button type="button" class="remove">
        <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12"></path></svg>
    </button>
</div>`;
                element.innerHTML = html;

                const $btnRemove = element.querySelector('button.remove');
                $btnRemove.addEventListener('click', event => {
                    const $span = element.querySelector('span');
                    const ad = $span.textContent;
                    this.removeAddress(ad);
                });

                if(!this.addressesNotReleased.includes(address)) {
                    element.querySelector('button.info').remove();
                }

                this.$list.appendChild(element);
            });
        }
    }

    // liefert Liste der aktuelle gewählten Adressen
    getAddresses() {

        // Liste der Adressen
        const addresses = this.$value.value.split(",");
        addresses.forEach((address, i) => {
            if(address === "")
                addresses.splice(i, 1);
        });

        return addresses;
    }

    // Adresse hinzufügen
    addAddress(address) {

        // Fehler ausblenden
        this.$modalError.classList.add('hidden');

        // Adresse nicht möglich
        const valid = this.validateNewAddress(address);
        if(valid !== true) {
            const p = this.$modalError.querySelectorAll('p');
            p.forEach($el => {
                if($el.classList.contains(valid)) {
                    $el.classList.remove('hidden');
                    this.$modalError.classList.remove('hidden');
                }
                else {
                    $el.classList.add('hidden');
                }
            });
            this.$modalError.classList.remove('hidden');
            return;
        }

        const success_function = () => {

            // Eingabe leeren
            const $input = this.$modalInputSelect.querySelector('input');
            $input.value = '';

            // Zur Liste der nichtfreigegebenen Adressen hinzufügen
            // ... wenn nicht in Auswahlliste
            let found = false;
            this.$modalInputSelect.querySelectorAll('select > option').forEach($option => {
                if($option.getAttribute('value') === address) {
                    found = true;
                }
            });
            if(!found) {
                this.addressesNotReleased.push(address);
            }

            // Adresse hinzufügen
            const addresses = this.getAddresses();
            addresses.push(address);
            this.$value.value = addresses.join(',');
            this.updateList();
            this.modal.close();
        }

        // direkte Speicherung
        if(this.storing) {

            let url = '';
            const data = new FormData();
            if(this.storing === 'form') {
                url = App.getUrl('form-delivery')+"/"+this.form_code+"/mailing/add_mail";
            }
            else if(this.storing === 'account') {
                url = App.getUrl('profile', 'add_mail');
            }
            data.append("address", address);

            // Meldungen ausblenden
            new Notification().hideAll();

            // Senden
            new Fetch().post(url, data)
            .then(response => {

                // Erfolgreich
                success_function();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                new Notification().error(error.message);
            });
        }
        else {
            success_function();
        }
    }

    // Adresse aus Liste entfernen
    removeAddress(address) {

        const success_function = () => {

            const addresses = this.getAddresses();
            let newList = [];
            addresses.forEach((a, i) => {
                if(a !== address)
                    newList.push(a);
            });
            this.$value.value = newList.join(',');
            this.updateList();
        }

        // direkte Speicherung
        if(this.storing) {

            let url = '';
            const data = new FormData();
            if(this.storing === 'form') {
                url = App.getUrl('form-delivery')+"/"+this.form_code+"/mailing/remove_mail";
            }
            else if(this.storing === 'account') {
                url = App.getUrl('profile', 'remove_mail');
            }
            data.append("address", address);

            // Meldungen ausblenden
            new Notification().hideAll();

            // Senden
            new Fetch().post(url, data)
            .then(response => {

                // Erfolgreich
                success_function();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                new Notification().error(error.message);
            });
        }
        else {
            success_function();
        }
    }

    // Prüft ob neue Adresse möglich ist
    validateNewAddress(address) {

        // keine Adresse angegeben
        if(address === "" || typeof address !== 'string')
            return 'format';

        // Format prüfen
        const re = /^\S+@\S+\.\S+$/;
        if(!re.test(address))
            return 'format';

        // bereits in der Liste
        const addresses = this.getAddresses();
        if(addresses.includes(address))
            return 'existing';

        // maximale Anzahl erreicht
        if(addresses.length >= this.maxCount)
            return 'count';

        // passt
        return true;
    }

    // Modal schliessen
    closeModal() {
        this.modal.close();
    }
}